import React from "react";

export function Tile({ title, rightSlot, children, className }) {
  return (
    <section className={`ss-tile ${className || ""}`}>
      {(title || rightSlot) && (
        <header className="ss-tile__header">
          {title && <h3 className="ss-tile__title">{title}</h3>}
          {rightSlot && <div className="ss-tile__right">{rightSlot}</div>}
        </header>
      )}

      <div className="ss-tile__body">{children}</div>
    </section>
  );
}